import { getAllTeams } from "../../../redux/index";
import { getNotifications } from "features";
import { connectorInit } from "features/integrations/reducer/ConnectorAction";
import { brandValueInit, cxGoalsInit, getAllCxMetrics, getAllInsightTypes, getAllStakeholderRoles, groupInit, iconsInit, libraryInit, measureInit, priorityInit, statusInit, tagInit, touchPointCategoriesInit, touchPointInit } from "features/library/reducer/LibraryActions";
import { getAllWorkspaces } from "features/workspace/reducer/WorkspaceActions";
import { getOrganizationSettings, getSubscriptionDetails } from "features/settings/reducer/SettingsActions";
import { getAllAuthorizedUsers, getAllRegisteredUsers, getAllRoles, getSettingUser } from "features/settings/reducer/UserActions";
import { Logout } from "features/auth/reducer/AuthActions";
import { updateAllStoresStates } from "shared/hooks/useNetworkStatus";

export const methodWorkspaceFun = (methodName, args, dispatch, userId) => {

    switch (methodName) {
        case "GET_ALL_WORKSPACE":
            dispatch(getAllWorkspaces());
            // dispatch(getAllAuthorizedUsers())
            // dispatch(getAllTeams())

            break;
        case "GET_ALL_LIBRARY":
            dispatch(libraryInit());
            break;
        case "GET_ALL_REGISTERED_USERS":
            dispatch(getAllWorkspaces());
            dispatch(getAllRegisteredUsers());
            
            if (args === userId) {
                dispatch(Logout());
            }
            break;
        case "GET_NOTIFICATIONS":
            getNotifications();
            break;
        case "GET_SUBSCRIPTION_DETAILS":
            dispatch(getSubscriptionDetails())
            break;
        case "GET_USER_SETTINGS":
            dispatch(getSettingUser())
            break;
        case "GET_ORGANIZATION_SETTINGS":
            dispatch(getOrganizationSettings())
            break;
        case "GET_ALL_AUTHORIZED_USERS":
            dispatch(getAllAuthorizedUsers())
            break;
        case "GET_ALL_ROLES":
            dispatch(getAllRoles())
            break;
        case "GET_ALL_TEAMS":
            dispatch(getAllTeams())
            break;
      
        case "GET_CONNECTOR":
            dispatch(connectorInit())
            break;
        case "GET_STATUS":
            dispatch(statusInit());
            break;
        case "GET_PRIORITIES":
            dispatch(priorityInit())
            break;
        case "GET_TOUCHPOINTS":
            dispatch(touchPointInit(args))
            break;
        case "GET_BRAND_VALUES":
            dispatch(brandValueInit())
            break;
        case "GET_ICONS":
            dispatch(iconsInit(args))
            break;
        case "GET_MEASURES":
            dispatch(measureInit())
            break;
        case "GET_INSIGHT_TYPES":
            dispatch(getAllInsightTypes())
            break;
        case "GET_TAGS":
            dispatch(tagInit())
            break;
        case "GET_GROUPS":
            dispatch(groupInit())
            break;
        case "GET_TOUCHPOINTSCATEGORIES":
            dispatch(touchPointCategoriesInit())
            break;
        case "GET_STAKEHOLDER_ROLES":
            dispatch(getAllStakeholderRoles())
            break;
        case "GET_CX_METRICS":
            dispatch(getAllCxMetrics())
            break;
        case "GET_CX_GOALS":
            dispatch(cxGoalsInit())
            break;
        case "UPDATE_PERSISTOR":
            updateAllStoresStates(dispatch)
            break;
        default:
            break;

    }
    return null;
}